import React from "react";

const PowerSolution: React.FC = () => {
  const features = [
    {
      number: "01",
      title: "High capacity battery ensures prolonged power backup.",
    },
    {
      number: "02",
      title: "Lightweight design, making it truly portable.",
    },
    {
      number: "03",
      title: "Multiple output ports for diverse energy needs.",
    },
    {
      number: "04",
      title: "Eco-friendly, promoting sustainable energy consumption.",
    },
  ];

  return (
    <div className="w-full bg-white">
      <section className="flex items-center justify-center bg-stone-900 px-8 py-8">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-center lg:flex-row">
          <div className="flex flex-1 flex-col items-start justify-center px-4 py-8 lg:px-8 lg:py-0">
            <h1 className="mb-6 text-4xl font-bold text-white md:text-5xl lg:text-6xl">
              Step Into a World of Uninterrupted Power
            </h1>
          </div>

          <div className="flex flex-1 items-center justify-center px-4 py-8 lg:py-0">
            <div className="h-64 w-full max-w-md md:h-80 lg:h-96">
              <img
                src="/technoblack.png"
                alt="Portable Power Station"
                className="h-full w-full object-cover"
                onError={(e) => {
                  (e.target as HTMLImageElement).className =
                    "h-full w-full bg-gradient-to-br from-blue-400 to-purple-500";
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="flex items-center justify-center bg-white px-8 py-12">
        <div className="max-w-7xl text-center">
          <div className="mb-4 flex justify-center">
            <div className="h-px w-96 bg-gray-300"></div>
          </div>
          <h2 className="mb-4 text-2xl font-semibold text-gray-700 md:text-3xl">
            Powering Lives, One Charge at a Time
          </h2>
          <div className="mb-6 flex justify-center">
            <div className="h-px w-96 bg-gray-300"></div>
          </div>
          <p className="mx-auto max-w-2xl text-lg text-gray-600 md:text-xl">
            At Devananta, we believe in providing solutions for a seamlessly
            powered world. Our state-of-the-art portable power stations are
            designed to redefine energy independence, ensuring that no matter
            where you are, power is always within reach.
          </p>
        </div>
      </section>

      <section className="bg-stone-800 px-4 sm:px-6 md:px-8 lg:px-10 xl:px-20 py-8 sm:py-10 md:py-12 lg:py-14">
        <div className="mx-auto max-w-7xl">
          <h2 className="mb-6 sm:mb-8 md:mb-10 lg:mb-12 text-center text-2xl sm:text-3xl md:text-4xl font-bold text-white">
            Features that Make a Difference
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-4 sm:gap-5 md:gap-6">
            {features.map((feature, index) => (
              <div
                key={index}
                className="flex flex-col items-start text-left p-3 sm:p-4 md:p-5 rounded-lg sm:rounded-xl hover:bg-stone-700/50 transition-colors duration-300"
              >
                <span className="mb-2 sm:mb-3 text-xl sm:text-2xl md:text-3xl font-bold text-blue-400">
                  {feature.number}
                </span>
                <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-300 leading-relaxed">
                  {feature.title}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default PowerSolution;
